// ============================================================
// TMR Portal Admin — Crédito → Aprovação manual (rota /credito/aprovacoes) (26 §9)
// ============================================================
import { useNavigate } from 'react-router-dom';
import { PageHeader, Table, Td } from '../../components/ui';
import { EmptyState, ErrorState, Skeleton } from '../../components/states';
import { PERMISSIONS, usePermission } from '../../data/PermissionsProvider';
import { useManualReviews } from '../../data/credit/queries';
import { clinicLabel, reasonLabel, waitingLabel } from '../../data/credit/status';
import { formatDay } from '../../data/businessRules/status';

/**
 * The sales the credit rating sent to the TMR, oldest first, with how long each has waited. Only the clinics in the
 * operator's scope; a row opens the evaluation, where the decision is taken.
 */
export function ManualReviewsPage() {
  const navigate = useNavigate();
  const canRead = usePermission(PERMISSIONS.creditReviewsRead);
  const query = useManualReviews(canRead);

  if (!canRead) {
    return (
      <div className="pa-screen" style={{ padding: 24 }}>
        <div className="pa-card">
          <EmptyState message="Você não tem permissão para ver a Análise de Aprovação." hint="Peça o acesso a quem administra os papéis." />
        </div>
      </div>
    );
  }

  return (
    <div className="pa-screen" style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 20 }}>
      <PageHeader
        eyebrow="Análise de Aprovação"
        title="Aprovação manual"
        desc="As vendas que o rating de aprovação mandou para a TMR. A clínica continua montando; proposta e condição esperam a decisão."
      />

      {query.isPending ? (
        <Skeleton rows={4} />
      ) : query.isError ? (
        <ErrorState error={query.error} onRetry={() => void query.refetch()} />
      ) : query.data.items.length === 0 ? (
        <div className="pa-card">
          <EmptyState message="Nenhuma venda aguardando a TMR." hint="Quando o rating segurar uma venda, ela aparece aqui." />
        </div>
      ) : (
        <Table
          columns={[
            { label: 'Paciente' },
            { label: 'Clínica' },
            { label: 'Motivo' },
            { label: 'Enviada em' },
            { label: 'Esperando' },
          ]}
        >
          {query.data.items.map((item) => (
            <tr
              key={item.evaluationId}
              className="pa-row"
              onClick={() => navigate(`/credito/aprovacoes/${item.evaluationId}`)}
              style={{ cursor: 'pointer' }}
            >
              <Td>
                <span style={{ fontWeight: 600 }}>{item.patientName}</span>
                {item.source === 'CpfCnpj' && (
                  <span style={{ display: 'block', fontSize: 12.5, color: 'var(--fg-subtle)' }}>Análise sem o Serasa</span>
                )}
              </Td>
              <Td>{clinicLabel(item.clinic)}</Td>
              <Td style={{ color: item.delinquentDebt ? 'var(--danger)' : undefined }}>
                {item.reasons.map(reasonLabel).join(' · ')}
              </Td>
              <Td>{formatDay(item.evaluatedAt)}</Td>
              <Td>{waitingLabel(item.evaluatedAt)}</Td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
